import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, AfterViewInit, Input, ViewContainerRef, ComponentRef, Renderer2 } from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

import { KYMW0B00Component } from '../../../commons/kymw0b/kymw0b00/kymw0b00.component';
import { KYMW0B00InputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-input.model';
import { KYMW0B00Model } from '../../../commons/kymw0b/kymw0b00/kymw0b00.model';
import { KYMW0B00OutputModel } from '../../../commons/kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { CommonSetting } from '../../../commons/kymw00/common-setting';
import { KYMW0E00Component } from '../../../commons/kymw0e/kymw0e00/kymw0e00.component';
import { KYMW0E00OutputModel } from '../../../commons/kymw0e/kymw0e00/vo/kymw0e00-output.model';
import { FileUploadService, FileAccept } from '../../../commons/kymw02/file-upload/file-upload.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

import { KYMW1600Model } from './kymw1600.model';
import { KYMW1600InputModel } from './vo/kymw1600-input.model';
import { GetImageInfoModel } from './vo/get-image-info.model';

import { ImageInfoDetailBoxComponent } from './image-info-detail-box/image-info-detail-box.component';
import { ImageInfoDetailComponent } from './image-info-detail/image-info-detail.component';

import { GetImageInfoService } from './api-services/get-image-info.service';
import { GetImageFileUrlService } from './api-services/get-image-file-url.service';
import { GetUseImageInfoService } from './api-services/get-use-image-info.service';
import { GetImageInfoDetailService } from './api-services/get-image-info-detail.service';
import { UpdateEnabledDeleteService } from './api-services/update-enabled-delete.service';
import { ReplaceImageFileUploadService } from './api-services/replace-image-file-upload.service';
import { ReplaceImageFileService } from './api-services/replace-image-file.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { UpdateImageInfoModel } from './vo/update-image-info.model';
import { ImageInfoListComponent } from './image-info-list/image-info-list.component';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { Subject } from 'rxjs';

import { KYMW1602Component } from '../kymw1602/kymw1602.component';
import { KYMW1602Model } from '../kymw1602/kymw1602.model';

/**
 * 画像確認画面を管理するクラス
 *
 * @export KYMW1600Component
 * @class KYMW1600Component
 */
@Component({
  selector: 'app-kymw1600',
  templateUrl: 'kymw1600.component.html',
  styleUrls: ['kymw1600.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1600Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  /** 画像プレビュー画像拡張子(png) */
  private static readonly KEY_IMAGE_PREVIEW_EXT = 'ImagePreviewExt';
  /** 画像ファイルの拡張子(eps) */
  private static readonly KEY_IMAGE_FILE_EXT = 'ImageFileExt';
  /** CWS画像ファイル拡張子(jpg) */
  private static readonly KEY_IMAGE_CWS_EXT = 'ImageCWSExt';
  /** 画像ファイル名(小) */
  private static readonly KEY_IMAGE_FILE_SMALL = 'ImageFileSmall';
  /** 画像ファイル名(中) */
  private static readonly KEY_IMAGE_FILE_MIDDLE = 'ImageFileMiddle';
  /** 画像ファイル名(大) */
  private static readonly KEY_IMAGE_FILE_LARGE = 'ImageFileLarge';

  // 部品のインスタンス化
  @ViewChild('imageInfoDetail', { static: false }) public vw_ImageInfoDetail: ImageInfoDetailComponent;
  @ViewChild('imageInfoList', { static: false }) public vw_ImageInfoList: ImageInfoListComponent;

  /* 画像差換用ファイルレパレンス */
  private fileRefList: Array<File>;
  private pngFileRef: File;
  private epsFileRef: File;
  private jpgSFileRef: File;
  private jpgMFileRef: File;
  private jpgLFileRef: File;
  private pngExt: string;                                                       // 画像プレビュー画像拡張子(png)
  private epsExt: string;                                                       // 画像ファイルの拡張子(eps)
  private jpgExt: string;                                                       // CWS画像ファイル拡張子(jpg)

  /** 画像確認画面起動用VO */
  private kymw1600InputVO: KYMW1600InputModel = null;

  /** 親画面からの連携値 */
  param: any;

  /** 自画面用のモデル */
  public kymw1600Model: KYMW1600Model = new KYMW1600Model();

  /** 画像検索画面用のモデル */
  public kymw0B00ModelParent: KYMW0B00Model = new KYMW0B00Model();

  /** 画像検索画面用のパラメータ */
  private kymw0B00InputVo: KYMW0B00InputModel = new KYMW0B00InputModel();

  /** コンテキストメニュー */
  private contextMenu: Menu;

  @Input() dispDialog: boolean = false;

  /** 画像拡大ダイアログ画面用 */
  public kymw1602Component: KYMW1602Component;
  private kymw1602ComponentRef: ComponentRef<any> = null;
  
  /**
   * コンストラクタ
   * Creates an instance of KYMW1600Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1600Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getImageInfoService: GetImageInfoService,
    private getImageFileUrlService: GetImageFileUrlService,
    private getUseImageInfoService: GetUseImageInfoService,
    private getImageInfoDetailService: GetImageInfoDetailService,
    private updateEnabledDeleteService: UpdateEnabledDeleteService,
    private replaceImageFileUploadService: ReplaceImageFileUploadService,
    private replaceImageFileService: ReplaceImageFileService,
    private updateImageInfoSevice: UpdateImageInfoService,
    private fileUploadService: FileUploadService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private fuctionMenuService: FunctionMenuService,
    public viewContainerRef: ViewContainerRef,
    public renderer: Renderer2,
  ) {
    super(kymw00Model);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW1500Component
   */
  public setInterfaceParam(param: KYMW1600InputModel): void {
    this.kymw1600InputVO = param;
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1600';

    this.kymw1600Model.kymw1600Component = this;

    this.kymw1600Model.funcPermission = this.getFuncPermission('KYMW1600');

    // メニュー初期設定
    if (!this.dispDialog) {
      this.initMenuBar();
    }
  }

  /**
   * ロード完了時処理
   *
   * @memberof KYMW1600Component
   */
  public ngAfterViewInit(): void {

    this.imageInfoDetailBox.componentEnabled = false;

    // 画像詳細情報の変更イベントを一括設定
    this.eventListenerSetting();

    // コンテキストメニュー初期設定
    this.initContextMenu();

    this.selfView.vw_ImageInfoList.btn_Search.nativeElement.focus();

    setTimeout(() => {
      if (this.kymw1600InputVO !== null) {
        // 使用画像選択で使用する検索条件保持
        const getImageInfoVO: GetImageInfoModel = this.kymw1600Model.createGetImageInfoVO(this.kymw1600InputVO);
        this.selfManage.imageInfoVO = getImageInfoVO;
        this.getImageInfoService.execute(this.kymw1600Model, getImageInfoVO);
      }
    });

  }

  /**
   * メニューの設定
   */
  private initMenuBar(): void {
    // ［ファイル］メニューを作成
    const menuEdit = new FMenu('#menuEdit', {
      header: '編集',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '検索', menuID: 'mi_KYMW0B00', enabled: true },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        switch (menuEdit.selectedItem.menuID) {
          case 'mi_KYMW0B00':
            // 画像検索画面を表示
            this.openKymw0B00();
            break;
          default:
            break;
        }
      }
    });
    this.fuctionMenuService.menus = [menuEdit]
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /** コンテキストメニューの初期設定 */
  private initContextMenu(): void {
    const contextMenuEnabledMode: boolean = (this.kymw00Model.kymw1001Model.topFuncReadOnlyMode) ? false : true;

    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '画像変更', cmd: 'imageChange', disabled: contextMenuEnabledMode },
        { caption: '画像拡大', cmd: 'imageZoom', disabled: contextMenuEnabledMode },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: (s, e) => {
        switch (this.contextMenu.selectedValue) {
          case 'imageChange':
            this.eventImageChange_MENU_SELECTHandler();
            break;
          case 'imageZoom':
            this.eventImageZOOM_MENU_SELECTHandler();
            break;
        }
      }
    });

    this.vw_ImageInfoList.hli_UseImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        this.eventContextMenu_MENUSELECTHandler(e);
        this.contextMenu.show(e);
      }
    });
  }

  /**
   * コンテキストメニューを呼び出した際のイベント
   * @param contextMenuEvent 呼び出し元イベントへの参照
   *
   */
  public eventContextMenu_MENUSELECTHandler(event: any): void {

    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode = Boolean(false);

    // 権限が閲覧権限でないか確認
    if (this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_READONLY) {
      // 権限が閲覧権限などであれば画像変更は実行させない
      contextMenuEnabledMode = false;
    } else {

      // 選択している値が存在するか
      if (this.selectedItem() !== null) {
        contextMenuEnabledMode = this.selectedItem().Status === '2';
      } else {
        // 存在していなければ画像変更は実行させない
        contextMenuEnabledMode = false;
      }
    }

    // 画像変更のコンテキストメニューアイテムを探し出し、権限を設定する
    this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
      if (item.caption === '画像変更') {
        item.enabled = contextMenuEnabledMode;
      }
    });
  }

  // 選択している画像情報を取得
  private selectedItem(): any {
    if (!PlessViewUtilsSub.isEmptyArray(this.selfManage.imageInfoList)) {
      const selectedIndex: number = this.selfManage.getSelectedImageIndex();
      return this.selfManage.imageInfoList[selectedIndex];
    }
    return null;
  }

  /**
   * 開始受注コードバインド
   */
  public bindStartOrderCodeTextInputSelectedOrderCode(orderCode: string): void {
    if (!PlessViewUtilsSub.isEmpty(orderCode) && this.imageInfoDetailBox.endOrderCode2 === '2') {
      this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(orderCode);
    }
  }

  /**
   * 終了開始受注コードコンボボックスバインド
   */
  public bindEndOrderCodeComboBox(index: string): void {
    if (index === '0') {
      this.imageInfoDetailBox.txiEndOrderCode1Disabled = false;
      this.imageInfoDetailBox.txitxiEndOrderCode1ReadOnly = false;
    } else if (index === '1') {
      this.imageInfoDetailBox.txiEndOrderCode1Disabled = true;
      this.imageInfoDetailBox.txitxiEndOrderCode1ReadOnly = false;
      this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode('');
    } else if (index === '2') {
      this.imageInfoDetailBox.txiEndOrderCode1Disabled = false;
      this.imageInfoDetailBox.txitxiEndOrderCode1ReadOnly = true;

      if (!PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode)) {
        this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(
          this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
      } else {
        this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode('');
      }
    }
  }

  /**
   * @copy jp.co.toppan.pless.common.view.PlessViewHelper#eventListenerSetting()
   */
  protected eventListenerSetting(): void {
    // 全体変更イベントを登録する
    ['txi_StartOrderCode', 'txi_EndOrderCode1', 'txi_Remarks',
      'txi_Priority', 'txi_CookingName', 'txi_MaterialName',
      'txi_KeyWord', 'txi_PhotoInstructContents', 'txi_Caption',
    ].forEach((objName: string) => {
      document.getElementById(objName).addEventListener('input', () => this.eventImageInfoDetailCHANGEHandler());
    });
    ['cmb_EndOrderCode2',
      'cmb_ProcessInstruct', 'ckb_CookingExPublish', 'cmb_CookingDiv',
      'cmb_EventId', 'cmb_PhotoContentsDiv', 'dfd_PhotoSchedule',
      'cmb_PhotoStudioId',
    ].forEach((objName: string) => {
      document.getElementById(objName).addEventListener('change', () => this.eventImageInfoDetailCHANGEHandler());
    });
  }

  /**
   * 終了ボタンイベント
   */
  public eventBtnClose_CLICKHandler(): void {
    if (this.selfManage.imageInfoDetailChangeFlg) {
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail: any) => {
        // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
        if (closeDetail === PlessAlert.Yes) {
          this.closeFunction();
        }
      });
    } else {
      // 画面を終了する
      this.closeFunction();
    }
  }

  /**
   * ページ遷移イベント
   */
  canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();
    if (this.selfManage.imageInfoDetailChangeFlg) {
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail: any) => {
        // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
        if (closeDetail === PlessAlert.Yes) {
          result.next(true);
        } else {
          result.next(false);
        }
      });
      return result;
    } else {
      // 画面を終了する
      return true;
    }
  }

  /**
   * 商品詳細情報変更イベント
   */
  public eventImageInfoDetailCHANGEHandler(): void {
    this.kymw1600Model.imageInfoDetailChangeFlg = true;
  }

  /**
   * 【画像リスト】検索ボタン
   */
  public eventBtnSearch_CLICKHandler(): void {
    if (this.selfManage.imageInfoDetailChangeFlg) {
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail: any) => {
        // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
        if (closeDetail === PlessAlert.Yes) {
          this.openKymw0B00();
        }
      });
    } else {
      // 画像検索画面を呼び出す
      this.openKymw0B00();
    }

  }

  private openKymw0B00() {
    // 画像検索画面を呼び出す
    const componentRef = this.dialogService.openModal(KYMW0B00Component);
    const instance = componentRef.componentInstance as KYMW0B00Component;
    instance.parent = this;
    instance.kymw0B00Model = this.kymw0B00ModelParent;
    instance.setInterfaceParam(this.kymw1600Model.getKYMW0B00InputVO());
    instance.setKYMW0B00Parameter = (outputVO: KYMW0B00OutputModel) => {
      const vo: GetImageInfoModel = this.kymw1600Model.getGetImageInfoVO(outputVO);
      this.selfManage.imageInfoVO = vo;
      this.getImageInfoService.execute(this.kymw1600Model, vo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 受注コード変更時
   */
  public eventOrderCode_CHANGEHandler(): void {
    // 受注コードのチェック
    if (!PlessViewUtilsSub.isEmpty(this.selfView.vw_ImageInfoList.txi_OrderCode.selectedCatalogID)) {
      // 使用画像選択ボタン活性
      this.plessEnabled(this.selfView.vw_ImageInfoList.btn_UseSearch, true);
      // 受注コードを保持
      this.selfView.vw_ImageInfoList.imageInfoListOrderCode = this.vw_ImageInfoList.txi_OrderCode.selectedOrderCode;
    } else {
      // 使用画像選択ボタン非活性
      this.plessEnabled(this.selfView.vw_ImageInfoList.btn_UseSearch, false);
    }
  }

  /**
   * 【画像リスト】使用画像選択ボタン
   */
  public eventBtnUseSearch_CLICKHandler(): void {
    // 画像詳細情報変更フラグがtrueｔ(変更あり)の場合、破棄確認メッセージを表示
    if (this.kymw1600Model.imageInfoDetailChangeFlg) {
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail: any) => {
        this.eventBtnUseSearch_CLICKHandlerClose(closeDetail);
      });
    } else {
      this.getUseImageInfoService.execute(this.kymw1600Model, this.selfManage.getUseImageInfoVO(this.selfManage.imageInfoVO));
    }
  }

  /**
   * 【画像リスト】使用画像選択ボタンアラートクローズイベント
   *
   * @param closeDetail:any
   */
  private eventBtnUseSearch_CLICKHandlerClose(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // Flex版でも処理がない。
    }
  }

  /**
   * 【画像リスト】画像出力ボタン
   */
  public eventImageOutput_CLICKHandler(): void {
    // 「画像出力」のチェックが全て解除状態の場合、下記メッセージを出力し、処理を終了する。
    if (!this.kymw1600Model.isImageSelected()) {
      this.dialogService.openAlertGetMessage('E0148', ['出力対象の画像']);
      return;
    }

    // 「EPSﾌｧｲﾙ」、「PNGﾌｧｲﾙ」の両方がチェック解除状態の場合、下記メッセージを出力し、処理を終了する。
    if (this.getExtension() === '0') {
      this.dialogService.openAlertGetMessage('E0148', ['出力対象のファイル形式']);
      return;
    }

    this.getImageFileUrlService.execute(this.kymw1600Model, this.kymw1600Model.getGetImageFileUrlVO(this.getExtension()), (data) => {
      // ローカルファイル名の作成   掲載組合員の声データ_YYYYMMDD.CSV
      const localfile: string = 'IMAGE_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';
      // ダウンロードの確認画面を起動する
      this.fileDownloadConfirmService.show(data.ImageFileUrl, localfile);
    });
  }

  /**
   * ファイル選択種類を取得する
   */
  private getExtension(): string {
    if (this.selfView.vw_ImageInfoList.chk_EPS.selected && this.selfView.vw_ImageInfoList.chk_PNG.selected
      && this.selfView.vw_ImageInfoList.chk_JPG.selected) {
      return '7';
    } else if (this.selfView.vw_ImageInfoList.chk_PNG.selected && this.selfView.vw_ImageInfoList.chk_JPG.selected) {
      return '6';
    } else if (this.selfView.vw_ImageInfoList.chk_EPS.selected && this.selfView.vw_ImageInfoList.chk_JPG.selected) {
      return '5';
    } else if (this.selfView.vw_ImageInfoList.chk_EPS.selected && this.selfView.vw_ImageInfoList.chk_PNG.selected) {
      return '4';
    } else if (this.selfView.vw_ImageInfoList.chk_JPG.selected) {
      return '3';
    } else if (this.selfView.vw_ImageInfoList.chk_PNG.selected) {
      return '2';
    } else if (this.selfView.vw_ImageInfoList.chk_EPS.selected) {
      return '1';
    } else {
      return '0';
    }
  }

  /**
   * 【画像リスト】画像クリック
   */
  public eventUseImageList_ITEMCLICKHandler(event: any): void {

    const list: any = event.imageInfoList;
    const idx: number = event.index;
    const group: any = event.useImageGroups;

    const selectedItem: any = list[idx];

    // 画像の背景色設定
    this.setImageBackColor(group, idx);

    if (this.selfManage.selectedImageId === selectedItem.ImageId) {
      return;
    }

    this.selfManage.tempSelectedImageId = selectedItem.ImageId;

    if (this.kymw1600Model.imageInfoDetailChangeFlg) {
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail: any) => {
        // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
        this.eventUseImageList_ITEMCLICKHandlerClose(closeDetail);
      });
    } else {
      this.selfManage.selectedImageId = this.selfManage.tempSelectedImageId;
      this.getImageInfoDetailService.execute(this.kymw1600Model, this.kymw1600Model.getGetImageInfoDetailVO());
    }

    // 画面拡大ダイアログが表示されている場合、画像が選択された画像に変わる
    if (this.isOpened('KYMW1602')) {
      this.kymw1602Component.KYMW1602Model.goodsImage = selectedItem.ImagePath;
      this.kymw1602Component.setImageScale();
    }
  }

  /**
   * 画像の背景色を設定する
   *
   * @param {HTMLElement} imageGroups
   * @param {number} index
   * @memberof KYMW1600Component
   */
  public setImageBackColor(imageGroups: HTMLElement = null, index = -1) {
    // 全ての画像グループの背景色をもとに戻す
    for (let i = Number(0); i < this.vw_ImageInfoList.useImageGroups.nativeElement.children.length; i++) {
      this.vw_ImageInfoList.useImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }

    // indexの指定がない場合は未選択
    if (index === -1) {
      return;
    }

    // 選択した画像の背景色を設定
    imageGroups.children[index].classList.add('image-selected');
  }

  /**
   * 【画像リスト】商品情報クリックアラートクローズイベント
   */
  private eventUseImageList_ITEMCLICKHandlerClose(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      this.selfManage.selectedImageId = this.selfManage.tempSelectedImageId;
      this.getImageInfoDetailService.execute(this.kymw1600Model, this.selfManage.getGetImageInfoDetailVO());
      this.kymw1600Model.imageInfoDetailChangeFlg = false;
    } else {
      const index = this.kymw1600Model.getSelectedImageIndex();
      this.vw_ImageInfoList.hli_UseImageList.nativeElement.selectedIndex = index;

      // 全ての画像グループの背景色をもとに戻す
      for (let i = Number(0); i < this.vw_ImageInfoList.useImageGroups.nativeElement.children.length; i++) {
        this.vw_ImageInfoList.useImageGroups.nativeElement.children[i].classList.remove('image-selected');
      }

      // 選択した画像の背景色を設定
      this.vw_ImageInfoList.useImageGroups.nativeElement.children[index].classList.add('image-selected');
    }
  }

  /**
   * 【画像リスト】全選択ボタンクリックイベント
   */
  public eventAllSelect_CLICKHandler(): void {
    this.kymw1600Model.updateAllSelect(true);
  }

  /**
   * 【画像リスト】全解除ボタンクリックイベント
   */
  public eventAllUnSelect_CLICKHandler(): void {
    this.kymw1600Model.updateAllSelect(false);
  }

  /**
   * 【画像詳細】リセットボタン
   */
  public eventReset_CLICKHandler(): void {
    this.getImageInfoDetailService.execute(this.kymw1600Model, this.kymw1600Model.getGetImageInfoDetailVO());
  }

  /**
   * 【画像詳細】設定ボタン
   */
  public eventSetting_CLICKHandler(): void {
    // チェック処理を行う
    this.dialogService.openAlertGetMessage('Q0108', ['画像情報'], (closeDetail: any) => {
      // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
      this.eventSettingClickHandlerClose(closeDetail);
    });
  }

  /**
   * 【画像詳細】設定ボタンクローズ
   */
  private eventSettingClickHandlerClose(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // 「使用開始受注コード」が未設定の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.startOrderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['使用開始受注コード']);
        return;
      }

      // 「使用開始受注コード」の存在チェック(isValidOrderCode)を行い、
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode)) {
        this.dialogService.openAlertGetMessage('W0024', ['使用開始受注コード']);
        return;
      }

      // 「使用終了受注コード（コンボボックス）」が空白で、且つ、「使用終了受注コード(テキスト)」が未設定の場合
      if (this.imageInfoDetailBox.endOrderCode2 === '0'
        && PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.endOrderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['使用終了受注コード']);
        return;
      }

      // 「使用終了受注コード（テキスト）」が設定されている場合、存在チェック(isValidOrderCode)を行い、処理結果がFalseの場合、
      if (this.imageInfoDetailBox.endOrderCode2 === '0'
        && PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode)) {
        this.dialogService.openAlertGetMessage('W0024', ['使用終了受注コード']);
        return;
      }

      // 「使用開始受注コード」　と 「使用終了受注コード（テキスト）」が共に設定されている場合、「使用開始受注コード」　≦ 「使用終了受注コード（テキスト）」　の相関チェックを行い、　エラーの場合
      if (!PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode)
        && !PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode)) {
        if (Number(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode)
          > Number(this.imageInfoDetailBox.txi_EndOrderCode1.selectedOrderCode)) {
          this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
          return;
        }
      }

      // 「撮影予定日」が未設定の場合、以下のメッセージを表示して処理を終了する。
      if (this.imageInfoDetailBox.dfd_PhotoSchedule.value == null) {
        this.dialogService.openAlertGetMessage('E0110', ['撮影予定日']);
        return;
      }

      // 「撮影場所」が未設定の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.photoStudioId)) {
        this.dialogService.openAlertGetMessage('W0001', ['撮影場所']);
        return;
      }

      //  画像種別が「調理イメージ」の場合で、「調理指示」が未選択の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.nullToBlank(this.kymw1600Model.imageType) === 'C' &&
        PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.processInstruct)) {
        this.dialogService.openAlertGetMessage('E0103', ['調理指示']);
        return;
      }

      // 「優先度」が未設定の場合、'5' で補正する。
      if (PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.priority)) {
        this.imageInfoDetailBox.priority = '5';
      }

      // 『使用ページ確認画面』の「使用画像チェック処理」を行う。
      this.openModalKymw0E00(1);
    }
  }

  private openModalKymw0E00(processDiv: number) {
    // 『使用ページ確認画面』の「使用画像チェック処理」を行う。
    const componentRef = this.dialogService.openModal(KYMW0E00Component);
    const instance = componentRef.componentInstance as KYMW0E00Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw1600Model.getKYMW0E00InputVO(processDiv));
    instance.setKYMW0E00Parameter = (outputVO: KYMW0E00OutputModel) => {
      this.setKYMW0E00Parameter(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【画像詳細】使用停止ボタン
   */
  public eventUseStop_CLICKHandler(): void {
    this.dialogService.openAlertGetMessage('Q0126', [], (closeDetail: any) => {
      this.eventUseStop_CLICKHandlerClose(closeDetail);
    });
  }

  /**
   * 【画像詳細】使用停止ボタンアラートクローズイベント
   */
  private eventUseStop_CLICKHandlerClose(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      this.openModalKymw0E00(2);
    }
  }

  /**
   * 【画像詳細】使用停止解除ボタン
   */
  public eventUseUnStop_CLICKHandler(): void {
    this.dialogService.openAlertGetMessage('Q0127', [], (closeDetail: any) => {
      this.eventUseUnStop_CLICKHandlerClose(closeDetail);
    });
  }

  /**
   * 【画像詳細】使用停止解除ボタンアラートクローズイベント
   */
  private eventUseUnStop_CLICKHandlerClose(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      this.updateEnabledDeleteService.execute(this.kymw1600Model, this.kymw1600Model.getUpdateEnabledDeleteVO('2'));
    }
  }

  /**
   * 【画像詳細】削除ボタン
   */
  public eventDelete_CLICKHandler(): void {
    this.dialogService.openAlertGetMessage('Q0106', ['選択中の画像ファイル情報'], (closeDetail: any) => {
      this.eventDelete_CLICKHandlerClose(closeDetail);
    });
  }

  /**
   * 【画像詳細】削除ボタンアラートクローズイベント
   */
  private eventDelete_CLICKHandlerClose(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      this.openModalKymw0E00(3);
    }
  }

  /**
   * コンテキストメニュー画像変更ボタン押下イベント
   */
  public eventImageChange_MENU_SELECTHandler(): void {
    this.dialogService.openAlertGetMessage('Q0133', [], (closeDetail: any) => {
      this.eventImageChange_MENU_SELECTHandlerClose(closeDetail);
    });

  }

  /**
   * 画像差替確認後イベント
   */
  private eventImageChange_MENU_SELECTHandlerClose(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      this.pngExt = CommonSetting.getVal(KYMW1600Component.KEY_IMAGE_PREVIEW_EXT);
      this.epsExt = CommonSetting.getVal(KYMW1600Component.KEY_IMAGE_FILE_EXT);
      this.jpgExt = CommonSetting.getVal(KYMW1600Component.KEY_IMAGE_CWS_EXT);

      // ファイル選択ダイアログを開く
      this.fileUploadService.upload((selectedFiles: File[]) => {
        // 選択したファイルの拡張子チェック
        for (let i = Number(0); i < selectedFiles.length; i++) {
          const extension = PlessViewUtilsSub.getExtension(selectedFiles[i].name);
          if (extension !== 'eps' && extension !== 'png' && extension !== 'jpg') {
            this.dialogService.openAlertGetMessage('E0220');
            return;
          }
        }
        this.fileRefList = selectedFiles;
        this.eventFileRef_SELECTHandler();
      }, [FileAccept.EPS, FileAccept.PNG, FileAccept.JPG], true);
    }
  }

  /**
   * 画像差替確認後イメージ選択ダイアログ選択イベント
   */
  public eventFileRef_SELECTHandler(): void {
    const sPrefix: string = CommonSetting.getVal(KYMW1600Component.KEY_IMAGE_FILE_SMALL);
    const mPrefix: string = CommonSetting.getVal(KYMW1600Component.KEY_IMAGE_FILE_MIDDLE);
    const lPrefix: string = CommonSetting.getVal(KYMW1600Component.KEY_IMAGE_FILE_LARGE);

    // チェック処理を行う
    this.pngFileRef = this.getImageFileRef(this.fileRefList, '.' + this.pngExt, '');
    this.epsFileRef = this.getImageFileRef(this.fileRefList, '.' + this.epsExt, '');
    this.jpgSFileRef = this.getImageFileRef(this.fileRefList, '.' + this.jpgExt, sPrefix);
    this.jpgMFileRef = this.getImageFileRef(this.fileRefList, '.' + this.jpgExt, mPrefix);
    this.jpgLFileRef = this.getImageFileRef(this.fileRefList, '.' + this.jpgExt, lPrefix);

    // 6個以上のファイルが選択されたのか
    if (this.fileRefList.length > 5) {
      this.dialogService.openAlertGetMessage('E0509');
      return;
    }
    // PNGファイルが選択されたのか
    if (this.pngFileRef == null) {
      this.dialogService.openAlertGetMessage('E0224', [CommonSetting.getVal('ImagePreviewExt')]);
      return;
    }
    // EPSファイルが選択されたのか
    if (this.epsFileRef == null) {
      this.dialogService.openAlertGetMessage('E0224', [CommonSetting.getVal('ImageFileExt')]);
      return;
    }
    // 同一名前のファイルが選択されたのか
    if (this.pngFileRef.name.replace(CommonSetting.getVal('ImagePreviewExt'), '')
      !== this.epsFileRef.name.replace(CommonSetting.getVal('ImageFileExt'), '')) {
      this.dialogService.openAlertGetMessage('E0225');
      return;
    }

    // JPGファイルが指定された場合
    if (this.jpgSFileRef !== null || this.jpgMFileRef !== null || this.jpgLFileRef !== null) {
      // JPGファイルは３サイズセットで選択されたか
      if (this.jpgSFileRef == null || this.jpgMFileRef == null || this.jpgLFileRef == null) {
        this.dialogService.openAlertGetMessage('E0508');
        return;
      }
      // 同一名前のファイルが選択されたのか
      if (this.pngFileRef.name.replace('.' + this.pngExt, '') !== this.jpgSFileRef.name.replace(sPrefix + '.' + this.jpgExt, '')) {
        this.dialogService.openAlertGetMessage('E0225');
        return;
      }
      // 同一名前のファイルが選択されたのか
      if (this.pngFileRef.name.replace('.' + this.pngExt, '') !== this.jpgMFileRef.name.replace(mPrefix + '.' + this.jpgExt, '')) {
        this.dialogService.openAlertGetMessage('E0225');
        return;
      }

      // 同一名前のファイルが選択されたのか
      if (this.pngFileRef.name.replace('.' + this.pngExt, '') !== this.jpgLFileRef.name.replace(lPrefix + '.' + this.jpgExt, '')) {
        this.dialogService.openAlertGetMessage('E0225');
        return;
      }
    }

    this.kymw1600Model.tempEPSFileName = '';
    this.kymw1600Model.tempPNGFileName = '';
    this.kymw1600Model.tempJPGSFileName = '';
    this.kymw1600Model.tempJPGMFileName = '';
    this.kymw1600Model.tempJPGLFileName = '';

    const vo = this.kymw1600Model.getReplaceImageFileUploadVO(this.pngFileRef);
    this.replaceImageFileUploadService.execute(this.kymw1600Model, vo, () => {
      this.eventPNGFileRefUploadSUCCESS();
    });
  }

  /**
   * PNGファイルアップロード成功時
   */
  private eventPNGFileRefUploadSUCCESS(): void {
    const vo = this.kymw1600Model.getReplaceImageFileUploadVO(this.epsFileRef);
    this.replaceImageFileUploadService.execute(this.kymw1600Model, vo, () => {
      this.eventJPGSFileRefUploadSUCCESS();
    });
  }

  /**
   * JPG(小)ファイルアップロードイベント
   */
  private eventJPGSFileRefUploadSUCCESS(): void {
    if (this.jpgSFileRef !== null) {
      // 次クライアント処理を「JPG(中)ファイルアップロードイベント」に設定し、
      // JPG(小)ファイルアップロード処理を実行
      const vo = this.kymw1600Model.getReplaceImageFileUploadVO(this.jpgSFileRef);
      this.replaceImageFileUploadService.execute(this.kymw1600Model, vo, () => {
        this.eventJPGMFileRefUploadSUCCESS();
      });
    } else {
      // EPSファイルアップロード処理を実行
      this.eventEPSFileRefUploadSUCCESS();
    }
  }

  /**
   * JPG(中)ファイルアップロードイベント
   */
  private eventJPGMFileRefUploadSUCCESS(): void {
    // 次クライアント処理を「JPG(大)ファイルアップロードイベント」に設定し、
    // JPG(中)ファイルアップロード処理を実行
    const vo = this.kymw1600Model.getReplaceImageFileUploadVO(this.jpgMFileRef);
    this.replaceImageFileUploadService.execute(this.kymw1600Model, vo, () => {
      this.eventJPGLFileRefUploadSUCCESS();
    });
  }

  /**
   * JPG(大)ファイルアップロードイベント
   */
  private eventJPGLFileRefUploadSUCCESS(): void {
    // 次クライアント処理を「EPSファイルアップロードイベント」に設定し、
    // JPG(大)ファイルアップロード処理を実行
    const vo = this.kymw1600Model.getReplaceImageFileUploadVO(this.jpgLFileRef);
    this.replaceImageFileUploadService.execute(this.kymw1600Model, vo, () => {
      this.eventEPSFileRefUploadSUCCESS();
    });
  }

  /**
   * EPSファイルアップロード完了時イベント
   */
  private eventEPSFileRefUploadSUCCESS(): void {
    const vo = this.kymw1600Model.getReplaceImageFileVO();
    this.replaceImageFileService.execute(this.kymw1600Model, vo, (serverData) => {
      this.eventReplaceImageFileSUCCESS(serverData);
    });
  }

  /**
   * ファイルアップロード完了イベント完了
   */
  private eventReplaceImageFileSUCCESS(serverData): void {
    this.kymw1600Model.reloadSelectedGoodsImage(serverData);
  }

  /**
   * イメージファイル名取得
   *
   * @param fileRefList:ファイルリファレンス配列
   * 			type:ファイルタイプ
   * 			prefix:接頭語(S, M, L)
   * @return FileReference
   */
  private getImageFileRef(fileRefList: Array<any>, type: string, prefix: string): any {
    for (let i = Number(0); i < fileRefList.length; i++) {
      if (this.splitExt(fileRefList[i].name) === type) {
        if (type === '.' + this.jpgExt) {
          const sName: string = fileRefList[i].name;
          if (sName.substr(sName.length - (prefix + type).length, (prefix + type).length).toUpperCase() === (prefix + type).toUpperCase()) {
            return fileRefList[i];
          }
        } else {
          return fileRefList[i];
        }
      }
    }

    return null;
  }

  /**
   * 拡張子を取得
   */
  private splitExt(filename: string): string {
    const a = filename.split(/(?=\.[^.]+$)/);
    return a[1];
  }

  /**
   * ViewHelperのviewをキャストして返すgetterメソッド。
   *
   * @return キャストされたKYMW1600
   */
  public get selfView(): KYMW1600Component {
    return this;
  }

  /**
   * 自分のマネージャーを取得する
   *
   * @return KYMW1600Manage
   */
  private get selfManage(): KYMW1600Model {
    return this.kymw1600Model;
  }

  /**
   * 画像詳細情報VBOX取得
   */
  public get imageInfoDetailBox(): ImageInfoDetailBoxComponent {
    return this.vw_ImageInfoDetail.imageInfoDetailBox;
  }

  /**
   * 画像検索画面によるパラメータ取得
   *
   * @param outputVO:KYMW0B00OutputVO;
   */
  public setKYMW0B00Parameter(outputVO: KYMW0B00OutputModel): void {
    const vo: GetImageInfoModel = this.kymw1600Model.getGetImageInfoVO(outputVO);
    this.getImageInfoService.execute(this.kymw1600Model, vo);
    // 使用画像選択で使用する検索条件保持
    this.kymw1600Model.imageInfoVO = vo;
  }

  /**
   * 使用ページ確認画面によるパラメータ取得
   *
   * @param outputVO:KYMW0B00OutputVO;
   */
  public setKYMW0E00Parameter(outputVO: KYMW0E00OutputModel): void {
    // キャンセルの場合
    if (outputVO.changeButton === 2) {
      return;
    }

    switch (outputVO.processDiv) {
      case 1:	// 使用範囲変更時
        const updateImageInfoVO: UpdateImageInfoModel = this.kymw1600Model.getUpdateImageInfoVO();
        this.updateImageInfoSevice.execute(this.kymw1600Model, updateImageInfoVO);
        break;

      case 2:	// 使用停止時
        const updateEnabledVO: any = this.kymw1600Model.getUpdateEnabledDeleteVO('1');
        this.updateEnabledDeleteService.execute(this.kymw1600Model, updateEnabledVO);
        break;

      case 3: // 削除時
        const updateDeleteVO: any = this.kymw1600Model.getUpdateEnabledDeleteVO('3');
        this.updateEnabledDeleteService.execute(this.kymw1600Model, updateDeleteVO);
        break;
    }
  }

  /**
   * 画像拡大ダイアログ表示
   */
  public eventImageZOOM_MENU_SELECTHandler() {
    if (!this.isOpened('KYMW1602')) {
      const KYMW1602VO: KYMW1602Model = new KYMW1602Model();
      KYMW1602VO.goodsImage = this.kymw1600Model.goodsImage;

      this.kymw1602ComponentRef = this.dialogService.openModelessSub(
        this, KYMW1602Component, this.viewContainerRef,
        this.kymw1602ComponentRef, KYMW1602VO, 0, '', true );
      if (this.kymw1602ComponentRef != null) {
        this.kymw1602Component = this.kymw1602ComponentRef.instance as KYMW1602Component;
        this.kymw1602Component.inputParameterSetting();
        this.kymw1602Component.parent = this;
        this.kymw1602Component.setKYMW1602Parameter = (vo: KYMW1602Model) => {
          this.setKYMW1602Parameter(vo);
        };
      
        // ウィンドウが閉じられる際の処理
        this.kymw1602Component.closeFunction = () => {
          this.kymw1602ComponentRef.destroy();
        };
      }

      // KYMW1600画像確認がモーダルダイアログ表示の場合
      // モーダル⇒モードレスの場合、モーダルの中にモードレス画面を入れる
      if (this.dispDialog) {
        // 1602画面を 1600画面の親要素に追加する
        const elKymw1600 = this.elementRef.nativeElement; // 自分(<app-kymw1600>)
        const elKymw1602 = this.kymw1602Component.elementRef.nativeElement; // 後から作成される画面(<app-kymw1602>)
        const parentElement1600 = this.renderer.parentNode(elKymw1600);
        this.renderer.appendChild(parentElement1600, elKymw1602);
      }
    }
  }

  public setKYMW1602Parameter(vo): void {
    this.kymw1602Component.setInputVO(vo);
  }
}
